import React, { useEffect , useState } from 'react'
import { Link } from 'react-router-dom'
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser'

export const LegalesInterna = (props) => {
    // const novedad = props.match.params.novedad;
    const id = props.match.params.id;

    const [legalesApi, setLegalesApi] = useState([]);
    useEffect(() => {
        fetch("/getSliders")
            .then(res => res.json())
            .then(result => {
              setLegalesApi(result);
            });
    }, []);

    var legalesToShow = null;
    if (legalesApi.length !== 0) {
        legalesApi.map(leg => {
            if (leg.id == id) {
                legalesToShow = leg;
            }
        });
    }

    // const _novedadesToShow = novedadesToShow
    // (novedad => {
    //     const year = novedad.created_at.substr(0,4)
    //     const month = novedad.created_at.substr(5,2)
    //     const day = novedad.created_at.substr(8,2)
    //     const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

    //     return {...novedad, created_at: `${day} de ${months[+month-1]} ${year}`};
    // })
    return (
        <div className="resultadosContainer">
            <div className="resultadosContainer--mainDiv">
                <div className="title">
                    <div className="title--container">
                        <Link to={'/'}>Legales</Link>
                    </div>
                </div>
            </div>
            <div className="novedadesInterna">
                <div className="novedadesInterna--container">
                    {legalesApi.map(legal =>(
                    // legalesToShow.length != 0 ? legalesToShow.map((legal)=>(
                   
                        <div id={legal.id}>
                            <div className="novedadesInterna--note">
                                <h1>{legal.legales_titulo}</h1>
                                <p>
                                {ReactHtmlParser(legal.legales_descripcion)}

                                </p>
                            </div>
                        </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}
